import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';
import SearchButton from '../../../../components/DriveItemList/Search/Button';
import { getMenuButtonIconSrc } from '../../../../utils/menuManager';

const searchPathname = '/list/search';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		search: { isShown },
		routing: { locationBeforeTransitions: { pathname } },
		galleryInfos: { config },
		driveList: { driveItems, resolutions },
		offlineManager: { thumbMap },
	} = state;
	const { icon } = ownProps;

	return {
		iconSrc: getMenuButtonIconSrc(icon, driveItems, config, thumbMap, resolutions),
		isActive: isShown || pathname.includes(searchPathname),
	};
};

export default connect(mapStateToProps)(SearchButton);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/Search/Button/index.tsx